import { render, staticRenderFns } from "./MypageRegularOrdersPage.vue?vue&type=template&id=4e2846aa&"
import script from "./MypageRegularOrdersPage.vue?vue&type=script&lang=js&"
export * from "./MypageRegularOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports